import { connect } from 'react-redux'

import { setCardProlonge } from '../../../../components/Basket/reducer'

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = { setCardProlonge }

const hocClubMemberHeader = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocClubMemberHeader
